import { render, staticRenderFns } from "./ListaFaq.vue?vue&type=template&id=c6adf0ae&scoped=true&"
import script from "./ListaFaq.vue?vue&type=script&lang=js&"
export * from "./ListaFaq.vue?vue&type=script&lang=js&"
import style0 from "./ListaFaq.vue?vue&type=style&index=0&id=c6adf0ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6adf0ae",
  null
  
)

export default component.exports